import {ModuleWithProviders, NgModule, Optional, SkipSelf} from "@angular/core";
import {I18nService} from "./i18n.service";
import {MissingTranslationHandler, TranslateParser} from "@ngx-translate/core";

@NgModule({})
export class I18nModule {
    constructor(@Optional() @SkipSelf() parentModule: I18nModule) {
        if (parentModule) {
            throw new Error('I18nModule is already loaded. Import it in the AppModule only');
        }
    }

    /**
     * Provide the I18nService both as itself and also as a TranslateParser and MissingTranslationHandler.
     * @return ModuleWithProviders
     */
    static forRoot(): ModuleWithProviders<I18nModule> {
        return {
            ngModule: I18nModule,
            providers: [
                I18nService,
                {provide: TranslateParser, useExisting: I18nService},
                {provide: MissingTranslationHandler, useExisting: I18nService}
            ]
        };
    }
}
